module.exports = __webpack_public_path__ + "img/post-blog-habilidades-tecnico-design-interiores.f878fa0f.png";